import React from "react";

export default function ProductSkeleton() {
  return (
    <div className="min-h-screen bg-[#f4f6f6] py-6 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <h1 className="text-xl sm:text-2xl font-semibold text-gray-800 mb-6">
          Marketplace
        </h1>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {Array.from({ length: 9 }).map((_, i) => (
            <div
              key={i}
              className="bg-white rounded-lg shadow-sm animate-pulse p-4 flex flex-col gap-3"
            >
              <div className="w-full h-40 bg-gray-200 rounded-md" />
              <div className="h-4 bg-gray-200 rounded w-3/4" />
              <div className="h-4 bg-gray-200 rounded w-1/2" />
              <div className="h-6 bg-gray-200 rounded w-1/3 mt-2" />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
